import Axios from 'axios';

export const fetchList = async (listType, itemType) => {

    if ((listType !== 'blocklist' && listType !== 'whitelist') || 
        (itemType !== 'items' && itemType !== 'users')) {
        return [];
    }

    const responseListName = itemType === 'items' ? 'item_ids' : 'user_ids';

    try {
        const response = await Axios({
            url: `/api/moderation/${listType}/${itemType}`,
            method: 'get',
        });

        if (response?.data?.data && response?.data?.data?.[responseListName] && response?.data?.data?.[responseListName].length > 0) {
            return response?.data?.data?.[responseListName];
        }
        else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching list', error);
        return [];
    }
};

export const updateList = async (listType, itemType, list) => {

    const url = `/api/moderation/${listType}/${itemType}`;
    const data = itemType === 'items' ? {
        item_ids: list,
    } : {
        user_ids: list,
    };

    try {
        await Axios({
            url: url,
            method: 'patch',
            data: data,
        });
        return true;
    } catch (error) {
        console.error('Error updating list', error);
        return false;
    }
}

export const fetchItemWarpcastLinkByHash = async (id) => {
    try {
        const response = await Axios({
            url: '/api/farcaster/cast',
            method: 'get',
            params: { identifier: id, type: 'hash' },
        });

        const warpCastPostLink = response?.data?.data?.warpCastPostLink || null;

        return warpCastPostLink || null;
    } catch (error) {
        console.error('Error fetching item details', error);
        return null;
    }
};

export const fetchUserWarpcastLinkByFid = async (value) => {
    try {
        const response = await Axios({
            url: '/api/farcaster/user/bulk',
            method: 'get',
            params: { fids: value },
        });

        const username = response?.data?.data && response?.data?.data?.length > 0 ? response?.data?.data[0]?.username : null;
        const warpCastProfileLink = `https://warpcast.com/${username}`;

        return warpCastProfileLink || null;
    } catch (error) {
        console.error('Error fetching user details', error);
        return null;
    }
};
